"use client";
import dynamic from "next/dynamic";
import type { ModuleComponents } from "./ModuleMapTypes";

const moduleHero = dynamic(() => import("@components/cms/hero/Hero").then((mod) => mod.Hero));
const moduleText = dynamic(() => import("@components/cms/text/Text").then((mod) => mod.Text));
const moduleImage = dynamic(() => import("@components/cms/image/Image").then((mod) => mod.Image));
const moduleVideo = dynamic(() => import("@components/cms/video/Video").then((mod) => mod.Video), {
    ssr: false,
});
const moduleSpacer = dynamic(() =>
    import("@components/cms/spacer/Spacer").then((mod) => mod.Spacer)
);
const moduleHotspot = dynamic(
    () => import("@components/cms/hotspot/Hotspot").then((mod) => mod.Hotspot),
    // Setting ssr to false will break SSR for some reason
    { ssr: true }
);
const moduleHeadline = dynamic(() =>
    import("@components/cms/headline/Headline").then((mod) => mod.Headline)
);
const moduleAccordion = dynamic(() =>
    import("@components/cms/accordion/Accordion").then((mod) => mod.Accordion)
);
const moduleHeroSlider = dynamic(() =>
    import("@components/cms/hero-slider/HeroSlider").then((mod) => mod.HeroSlider)
);
const moduleCardGeneric = dynamic(() =>
    import("@components/cms/card-generic/CardGeneric").then((mod) => mod.CardGeneric)
);
const moduleMultipleMedia = dynamic(() =>
    import("@components/cms/multiple-media/MultipleMedia").then((mod) => mod.MultipleMedia)
);
const moduleStoryTileGrid = dynamic(() =>
    import("@components/cms/story-tile-grid/StoryTileGrid").then((mod) => mod.StoryTileGrid)
);
const moduleCardLinkCollection = dynamic(() =>
    import("@components/cms/card-link-collection/CardLinkCollection").then(
        (mod) => mod.CardLinkCollection
    )
);
const moduleCustomProductCarousel = dynamic(() =>
    import("@components/cms/custom-product-carousel/CustomProductCarousel").then(
        (mod) => mod.CustomProductCarousel
    )
);
const moduleBackgroundColorWrapper = dynamic(() =>
    import("@components/cms/background-color-wrapper/BackgroundColorWrapper").then(
        (mod) => mod.BackgroundColorWrapperModule
    )
);

const moduleBazaarvoiceGallery = dynamic(() =>
    import("@components/cms/bazaarvoice-gallery-container/BazaarvoiceGalleryContainer").then(
        (mod) => mod.BazaarvoiceGalleryContainer
    )
);

// TypeScript can't infer specific props through dynamic() import, so we need to define the types explicitly
export const modulesMap: Partial<ModuleComponents> = {
    moduleHero, // Safe
    moduleText, // Safe
    moduleImage, // Safe
    moduleVideo, // Safe
    moduleSpacer, // Safe
    moduleHotspot, // Breaks SSR if {ssr:false}
    moduleHeadline, // Safe
    moduleAccordion, // Safe
    moduleHeroSlider, // Safe
    moduleCardGeneric, // Safe
    moduleMultipleMedia, // Unverified
    moduleStoryTileGrid, // Safe
    moduleCardLinkCollection, // Safe
    moduleCustomProductCarousel, // Safe
    moduleBackgroundColorWrapper, // Unverified
    moduleBazaarvoiceGallery, //Safe
};
